const ASSET_DEFAULTS = {
  miningFee: 0,
  minWithdrawal: 0,
};

const DEFAULT_PRICE_SCALE = 10;
const NA = 'N/A';

export { ASSET_DEFAULTS, DEFAULT_PRICE_SCALE, NA };
